import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { PartnerUserAdminDto } from "@colab/shared";

// GET /api/admin/users/partner-contacts — partner users across every partner
// (or a single partner when partnerId is given). Drives the Partner users tab.
export function usePartnerContacts(partnerId?: string) {
  return useQuery<PartnerUserAdminDto[], ApiClientError>({
    queryKey: queryKeys.users.partnerContacts(partnerId),
    queryFn: () =>
      apiFetch<PartnerUserAdminDto[]>(
        partnerId
          ? `/admin/users/partner-contacts?partnerId=${encodeURIComponent(partnerId)}`
          : "/admin/users/partner-contacts",
      ),
  });
}
